const NavigationBar = {
  state: { mini_drawer: true },
  mutations: {
    setOpposite(state) {
      state.mini_drawer = !state.mini_drawer;
    },
    minifyNavDrawer(state, val) {
      state.mini_drawer = val;
    },
  },
  getters: {
    getMiniDrawer: function(state) {
      return state.mini_drawer;
    },
  },
};
export default NavigationBar;
